var map = {
	"./dd_aa.json": "8749",
	"./dd_de.json": "d367",
	"./dd_en.json": "4704",
	"./dd_es.json": "46fe",
	"./dd_ja.json": "5105",
	"./dd_nl.json": "a22c",
	"./dd_pl.json": "5846",
	"./dd_pt.json": "856b",
	"./dd_tr.json": "a5c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46a5";